import { render, staticRenderFns } from "./CusorPagination.vue?vue&type=template&id=53d8709e"
import script from "./CusorPagination.vue?vue&type=script&lang=js"
export * from "./CusorPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports